let audioCtx = null;

export function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

// ✅ 成功音（レジ）
export function playSuccessSound() {
  const ctx = getAudioContext();
  const t = ctx.currentTime;

  const o = ctx.createOscillator();
  const g = ctx.createGain();

  o.type = "square";
  o.frequency.setValueAtTime(1800, t);

  g.gain.setValueAtTime(0.3, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.05);

  o.connect(g);
  g.connect(ctx.destination);

  o.start(t);
  o.stop(t + 0.05);
}

// ✅ エラー音
export function playErrorSound() {
  const ctx = getAudioContext();
  const t = ctx.currentTime;

  const o = ctx.createOscillator();
  const g = ctx.createGain();

  o.type = "sawtooth";
  o.frequency.setValueAtTime(200, t);

  g.gain.setValueAtTime(0.3, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.2);

  o.connect(g);
  g.connect(ctx.destination);

  o.start(t);
  o.stop(t + 0.2);
}
